import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { ioDispatcher3b9pa3x0duop as ioDispatcher } from '../../../../../ktor-ktor-io/io/ktor/utils/io/IODispatcher.web.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SilentSupervisorlzoikirj0zeo as SilentSupervisor } from '../../../../../ktor-ktor-utils/io/ktor/util/CoroutinesUtils.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Key_instance2rlngjw9v1qsd as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get_supportedCapabilities36x6e2ixit204 as get_supportedCapabilities,
  install34ed8l0uhurm0 as install,
  HttpClientEngine3f41d0b7i209y as HttpClientEngine,
} from './HttpClientEngine.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientEngineClosedExceptionClass;
function ClientEngineClosedException() {
  if (ClientEngineClosedExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static u5l(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.o('Client already closed');
        captureStack($this, $this.t5l_1);
        $this.s5l_1 = cause;
        delete $this.cause;
        return $this;
      }
      s() {
        return this.s5l_1;
      }
      get cause() {
        return this.s();
      }
    }
    initMetadataForClass($, 'ClientEngineClosedException', $.u5l);
    ClientEngineClosedExceptionClass = $;
  }
  return ClientEngineClosedExceptionClass;
}
function HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v() {
  return (p0) => p0.a5m();
}
function HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr() {
  return (p0) => p0.xv();
}
var HttpClientEngineBaseClass;
function HttpClientEngineBase() {
  if (HttpClientEngineBaseClass === VOID) {
    class $ {
      constructor(engineName) {
        this.w5l_1 = engineName;
        this.x5l_1 = atomic$boolean$1(false);
        var tmp = this;
        tmp.y5l_1 = lazy(() => {
          var tmp0_elvis_lhs = this.q5g().c5m_1;
          return tmp0_elvis_lhs == null ? ioDispatcher() : tmp0_elvis_lhs;
        });
        var tmp_0 = this;
        tmp_0.z5l_1 = lazy(() => SilentSupervisor().hm(this.a5m()).hm(new (CoroutineName())(this.w5l_1 + '-context')));
      }
      a5m() {
        var tmp0 = this.y5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('dispatcher', 1, tmp, HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v(), null);
        return tmp0.n3();
      }
      xv() {
        var tmp0 = this.z5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('coroutineContext', 1, tmp, HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr(), null);
        return tmp0.n3();
      }
      l6() {
        if (!this.x5l_1.atomicfu$compareAndSet(false, true))
          return Unit_instance;
        var tmp = this.xv().yc(Key_instance);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var requestJob = tmp_0;
        requestJob.p12();
      }
    }
    protoOf($).h5l = get_supportedCapabilities;
    protoOf($).r5g = install;
    initMetadataForClass($, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine()], [1]);
    HttpClientEngineBaseClass = $;
  }
  return HttpClientEngineBaseClass;
}
//region block: exports
export {
  ClientEngineClosedException as ClientEngineClosedException1qtw9cl0kd5fk,
  HttpClientEngineBase as HttpClientEngineBase2tgisnw4e4drr,
};
//endregion

//# sourceMappingURL=HttpClientEngineBase.mjs.map
